import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useRef, useState, useCallback, useEffect } from 'react';

var DEFAULT_SIDER_WIDTH = 400;
function useResizerSidebar(position, initialWidth) {
  var sidebarRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isResizing = _useState2[0],
    setIsResizing = _useState2[1];
  var _useState3 = useState(initialWidth !== null && initialWidth !== void 0 ? initialWidth : DEFAULT_SIDER_WIDTH),
    _useState4 = _slicedToArray(_useState3, 2),
    sidebarWidth = _useState4[0],
    setSidebarWidth = _useState4[1];
  var startResizing = function startResizing() {
    setIsResizing(true);
  };
  var stopResizing = function stopResizing() {
    setIsResizing(false);
  };
  var resize = useCallback(function (e) {
    var _sidebarRef$current2;
    if (!isResizing) {
      return;
    }
    if (position === 'right') {
      var _sidebarRef$current;
      var right = sidebarRef === null || sidebarRef === void 0 || (_sidebarRef$current = sidebarRef.current) === null || _sidebarRef$current === void 0 ? void 0 : _sidebarRef$current.getBoundingClientRect().right;
      if (!right && right !== 0) {
        return;
      }
      setSidebarWidth(right - e.clientX);
      return;
    }
    var x = sidebarRef === null || sidebarRef === void 0 || (_sidebarRef$current2 = sidebarRef.current) === null || _sidebarRef$current2 === void 0 ? void 0 : _sidebarRef$current2.getBoundingClientRect().x;
    if (!x && x !== 0) {
      return;
    }
    setSidebarWidth(e.clientX - x);
  }, [isResizing]);
  useEffect(function () {
    window.addEventListener('mousemove', resize);
    window.addEventListener('mouseup', stopResizing);
    return function () {
      window.removeEventListener('mousemove', resize);
      window.removeEventListener('mouseup', stopResizing);
    };
  }, [resize, stopResizing]);
  return [sidebarRef, startResizing, sidebarWidth];
}

export { useResizerSidebar };
//# sourceMappingURL=useResizerSidebar.js.map
